import ClientDetails from "./Container"

export default ClientDetails
